import { orgBillingCount, orgBillings } from '../../../api/orgTripAPI';
import errorHandle from '../../../utils/errorHandle';

export default async function orgBillingData(type, limit, offset, status, approval, setBillingData, setLoading) {
    setLoading(true);
    try {
        const billingData = await orgBillings(type, limit, offset, status, approval);
        setBillingData(billingData.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}

export const billingCount = (type, setTotalCount, status, selectedApproval, setLoading) => {
    setLoading(true);
    try {
        orgBillingCount(type, status, selectedApproval).then((res) => {
            setTotalCount(res.data.billsCount);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
